import { render, staticRenderFns } from "./BakiyeBorcMuhtirasininTebligeCikartilmasiTalepEvrakForm.vue?vue&type=template&id=e9124208"
import script from "./BakiyeBorcMuhtirasininTebligeCikartilmasiTalepEvrakForm.vue?vue&type=script&lang=ts"
export * from "./BakiyeBorcMuhtirasininTebligeCikartilmasiTalepEvrakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports